export const isFreightLoading = (freights) => Object.values(freights.getIn(['isLoading'])).includes(true);

export default isFreightLoading;
